export default {
      id: "icon-close-usage",
      viewBox: "0 0 18 2.571",
      url: __webpack_public_path__ + "img/icons.c8a27ec6.svg#icon-close",
      toString: function () {
        return this.url;
      }
    }